<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Relatório de Receitas Emitidas</div>
            <div class="subTitulo">
              Gere aqui o Excel com a listagem de receitas emitidas por período.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Data Inicial">
              <date-picker
                v-model="request.startDate"
                :first-day-of-week="0"
                format="YYYY-MM-DD"
                value-type="format"
                lang="pt-br"
                placeholder="dd/mm/yyyy"
                :class="{ empty: isSubmit && request.startDate === '' }"
              ></date-picker>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-2" label="Data Final">
              <date-picker
                v-model="request.endDate"
                :first-day-of-week="0"
                format="YYYY-MM-DD"
                value-type="format"
                lang="pt-br"
                placeholder="dd/mm/yyyy"
                :class="{ empty: isSubmit && request.endDate === '' }"
              ></date-picker>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <button class="btn btn-webreceita" @click="gerar">Gerar Excel</button>
          </div>
        </div>
      </div>
      <loading
        :active.sync="isLoading"
        color="#008e75"
        :can-cancel="true"
      ></loading>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import reportsService from '@/src/services/reports/reports'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'

export default {
  components: { Layout, Loading, DatePicker },
  data() {
    return {
      isLoading: false,
      isSubmit: false,
      request: {
        startDate: '',
        endDate: '',
      },
    }
  },
  watch: {
    request: {
      handler() {
        this.isSubmit = false
      },
      deep: true,
    },
  },
  methods: {
    async gerar() {
      if (!this.request.startDate || !this.request.endDate) {
        this.isSubmit = true
        this.$bvToast.toast('Preencha Data Inicial e Data Final.', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token

      reportsService
        .reportReceitasExcel(token, this.request.startDate, this.request.endDate)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
          const downloadUrl = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = downloadUrl
          link.download = 'relatorio_receitas_emitidas.xlsx'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(downloadUrl)
          this.isLoading = false
        })
        .catch((err) => {
          this.isLoading = false
          this.$bvToast.toast(
            (err.response && err.response.data && (err.response.data.msg || err.response.data.message)) ||
              'Ocorreu um erro ao gerar relatório',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
    },
  },
}
</script>

<style>
.empty {
  border: 1px solid red;
}
</style>
